import React from "react";
import { Link, useLoaderData } from "react-router-dom";
import Product from "../Product/Product";

const Products = () => {
  const countries = useLoaderData();


  return (
    <div>
      <h1>This is products page</h1>
      <h3>All countries : {countries.length}</h3>
      {
        countries.map(country => <Product
        key= {country.alpha3Code}
        country = {country}
        ></Product>)
      }
    </div>
  );
};

export default Products;
